<div class="support-phone-number-container" data-test="support-card">
  <div class="support-phone-number-icon-wrap">
    <iris-icon
      name="call"
      [size]="iconSize"
      [color]="iconColor"
    ></iris-icon>
  </div>
  <div>
    <p class="need-support">Need support?</p>
    Our Care Coordinators can assist you in booking a session at
    <a href="tel:{{ supportPhoneNumberLink }}">{{supportPhoneNumberDisplay}}</a>.
  </div>
</div>